import { Link } from "react-router-dom";

export default function PublicFooter() {
  return (
    <footer className="bg-foreground text-background/70 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="text-[11px] tracking-[0.32em] font-bold" style={{ color: "#A68A64", lineHeight: 1.05 }}>SUBTEND</div>
          <div className="text-[11px] tracking-[0.32em] font-bold text-background mt-1" style={{ lineHeight: 1.05 }}>STUDIO</div>
          <div className="text-[11px] tracking-[0.08em] mt-4" style={{ color: "#A68A64" }}>
            Design · Visualise · Price · Sell
          </div>
          <p className="mt-3 text-sm max-w-md">
            Design-to-proposal software built for media-wall businesses.
          </p>
        </div>
        <div>
          <div className="overline text-[10px]" style={{ color: "#A68A64" }}>Explore</div>
          <ul className="mt-3 space-y-2 text-sm">
            <li><Link to="/designs" className="hover:text-[color:hsl(var(--accent))]">Designs</Link></li>
            <li><Link to="/materials" className="hover:text-[color:hsl(var(--accent))]">Materials</Link></li>
            <li><Link to="/process" className="hover:text-[color:hsl(var(--accent))]">Process</Link></li>
            <li><Link to="/investment" className="hover:text-[color:hsl(var(--accent))]">Investment</Link></li>
          </ul>
        </div>
        <div>
          <div className="overline text-[10px]" style={{ color: "#A68A64" }}>Studio</div>
          <ul className="mt-3 space-y-2 text-sm">
            <li><Link to="/architects" className="hover:text-[color:hsl(var(--accent))]">For Architects</Link></li>
            <li><Link to="/about" className="hover:text-[color:hsl(var(--accent))]">About</Link></li>
            <li><Link to="/enquiry" className="hover:text-[color:hsl(var(--accent))]">Start a Project</Link></li>
            <li><Link to="/login" className="hover:text-[color:hsl(var(--accent))]">Studio Sign In</Link></li>
          </ul>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-6 lg:px-12 mt-14 pt-6 border-t border-white/10 text-xs flex flex-wrap justify-between gap-3">
        <span>© {new Date().getFullYear()} Subtend Studio</span>
        <span>Design-to-proposal software built for media-wall businesses.</span>
      </div>
    </footer>
  );
}
